import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"
import { makeBusyFunction } from "lib/@components/busy/make-busy-function"

export const moveSchedules = api(
    makeBusyFunction(
        (clientId, schedules) =>
            mutate(
                gql`
                    mutation MoveSchedules($clientId: String!, $schedules: [String!]!) {
                        moveSchedules(clientId: $clientId, schedules: $schedules)
                    }
                `,
                { clientId, schedules },
                { returns: "moveSchedules" }
            ),
        "Copying Schedules"
    )
)
